module.exports = {

    toLogin:{
        loginTip:'Demande de connexion',
        ifToLogin:'Si vous voulez aller à la connexion',
        token:'Connexion expirée, veuillez vous reconnecter',
        canel:'Canel',
        confirm:'confirmer',
    },
     DataSatName:{
        name1:'Vortex océanique mondial',
        name2:"L'invasion de criquets dans les déserts d'Asie et d'Afrique",
        name3:'Vortex océanique mondial'
    },
    banner:{
        title:'Big Earth Data pour les ODD',
        text1:'Connexions numériques, prospérité partagée, pour nos concitoyens, pour notre planète.',
        text2:' Des innovations fondées sur les données de Big Earth au service des objectifs de développement durable, pour un monde meilleur.',
    },
        // 导航菜单
    Nav: {
        Name: 'DBAR Big Earth Data Système',
        Menu: {
            Home: 'Accueil',
            DataHub: 'Données Services',
            Story:'ODD Histoire',
            Featured:'Dernière Info',
            Society: 'ODD et Société',
            Science: 'ODD et Technologie',
            Practices: 'Meilleures Pratiques',
            AppsMarket: 'Marché des Apps',
            Knowledgebase: 'Base de Connaissances',
            MySpace: 'Mon Espace',
            AboutUs: 'Sur',
            Contact: 'Contact',
            SDG: 'Sur ODD',
            Language: 'Langue',
            ZH:'Chinois',
            EN:'英文',
            Indicators: 'Indicateurs',
            Reports: 'Rapports',
            UnderDevelopment: 'En développement',
        },
        User: {
            Login: 'Pour vous connecter',
            Logout: 'Déconnect'
        }
    },
    Index: {
        Technology: {
            latest: 'Dernier'
        },
        Knowledge: {
            Indicators: 'ODD indicateurs',
            Reports: 'Rapports',
            TerraViewSDGs: 'TerraView-ODD'
        }
    },
    DataSerch:{
        key:'Recommander Word',
        dataSearch:'Recherche de données',
        filter:'Critères de filtrage',
        geosphere:'Géosphère',
        format:'Format',
        source:'Sources',
        more:'Plus',
        sort:'Trier par',
        defaultSort:'Tri par défaut',
        visits:'Visites',
        downloads:'Téléchargements',
        lastUpdated:'Dernière mise à jour',
        browsingData:'Parcourir Données',
        noData:'Pas de données',
       found:'Résultats associés pour vous',
       Prefix:'Trouvé',
       Collected:'Recueilli'
    },
    DataServer:{
        sdg1:'Pas de pauvreté ',
        sdg2:'Fain «zéro»',
        sdg3:'Bonne santé et bien-être',
        sdg4:'Éducation de qualité',
        sdg5:'Égalité entre les sexes',
        sdg6:'Eau propre et assainissement',
        sdg7:"Énergie propre et d'un coût abordable",
        sdg8:'Travail décent et croissance économique',
        sdg9:'Établir des modes de consommation et de production durables',
        sdg10:'Inégalités réduites',
        sdg11:'villes et communautés durables',
        sdg12:'consommation et production responsables',
        sdg13:'lutte contre les changements climatiques',
        sdg14:'Vie aquatique',
        sdg15:'Vie terrestre',
        sdg16:'Paix, justice et institutions efficaces',
        sdg17:'Renforcer les moyens de mettre en œuvre le Partenariat mondial pour le développement et le revitaliser.',
        sharingPlatform:'Plateforme de partage distribué',
        platformStatistics:"Statistiques d'accès",
        tagCloud:'Cloud d’étiquettes',
        mostPopular:'Zone la plus populaire',
        dataClassification:'Classification des données',
        topDataRanking:"Classements d'actualité",
        noData:'Pas de données',
        recentUpdates:'Mises à jour récentes',
        dataVolume:'Volume de données',
        numberfiles:'Nombre de fichiers',
        views:'Affichage',
        downloads:'Numéro de téléchargement',

        
    },
    MySpace:{
        downloadNum:'Numéro de téléchargement',
        dataReserve:'Réservation de données',
        shopping:'Panier',
        collectNum:'Numéro de collection',
        dataOrder:'Commandes de données',
        dataCollection:'Collecte de données',
        batchReserve:'Réservation par lots',
        batchDelete:'Suppression par lots',
        reserve:'Réservation',
        delete:'Suppression',
        dataSatName:'Nom des données',
        dataID:'Identification des données',
        createTime:'Temps de création',
        Operation:'Opération',
        orderNum:'Numéro de commande',
        orderStatus:'État de commande',
        dataSize:'Taille des données',
        orderTime:'Heure de commande',
        seen:'Vue',
        thumbnail:'Miniature',
        canelCollect:'Annuler la collecte',
        collectTime:'Temps de collecte',
        Finish:'Finir',
        inPreparation:'En préparation',
        ftp:{
            projectName:'Nom de la tâche',
            orderNum:'Numéro de commande',
            status:'État',
            adrees:'adresse ftp',
            FTPaccount:'Compte FTP',
            FTPpassword:'Mot de passe FTP',
            applicationNotes:"Notes d'application",
            dataSatName:'Nom des données',
            dataSize:'Taille des données',
            dataId:'Identification des données',
            createTime:'Temps de création',
        },
        tip:{
            deleteSelectFile:"Vous êtes sûr de vouloir supprimer le fichier de l'ensemble de données sélectionné ?",
            downloadTheFile:'Vous êtes sûr de vouloir télécharger le fichier ?',
            deleteTheFile:'Vous êtes sûr de vouloir supprimer ce fichier ?',
            dataReservation:'Données programmées',
            projectName:'Nom de la tâche',
            applicationNotes:"Notes d'application",
            download:'Télécharger',
            cancel:'Canel',
            confirm:'Confirmation',
            seleteDataEntry:'Veuillez sélectionner les données',
            PleaseFill:'Veuillez remplir les informations pertinentes',
            reservationSuccess:'Succès de la réservation de données',
            deleteSelectOrder:'Voulez-vous vraiment supprimer la commande sélectionnée ?',
            deleteTheOrder:'Voulez-vous vraiment supprimer la commande ?',
            order:'Informations sur la commande',
            delete:'Suppression',
            orderNum:'Numéro de commande',
            status:'État ',
            adrees:'adresse ftp',
            FTPaccount:'Compte FTP',
            FTPpassword:'Mot de passe FTP',
            uncollectSelectDatasat:'Vous êtes sûr de ne pas collecter un ensemble de données sélectionné ?',
            uncollecttheDatasat:'Vous êtes sûr de ne pas vouloir collecter cet ensemble de données ?',
        }
    },
    DataDetails:{
        Description:'Partagé au sein du projet, non disponible au téléchargement pour le moment.',
        Use:'Utilisations',
        Present:'Oui',
        NotPresent:'Aucun',
        tip:{
            dataEntry:'Veuillez sélectionner les données',
            successfully:'Données ajoutées avec succès',
            collectSuccessfully:'Succès de la collecte des données',
            failure:"Les données n'ont pas pu être ajoutées, veuillez contacter l'administrateur.",
            downloadData:'OK pour télécharger les données actuelles ?',
            cancel:'Canel',
            confirm:'Confirmer'
        },
        collectionDatasets:'Ensemble de données de collecte',
        dataHub:'Données Services',
        dataContributors:'Contributeurs de données',
        latestUpdate:'Dernière mise à jour',
        storageVolume:'Volume de stockage',
        visits:'Visites',
        downloads:'Téléchargements',
        mateInfo:{
            sharing1:'Partage intra-dédié',
            sharing2:'Partage publique',
            basicInformation:'Informations de base',
            productNumber:'Numéro de produit',
            dataType:'Type de données',
            dataFormat:'Format',
            Projection:'Projection',
            startDate:'Date de début',
            endDate:'Date de fin',
            spatialResolution:'Résolution spatiale',
            timeResolution:'Résolution temporelle',
            geographicalScope:'Champ d’application géographique',
            sharingMethod:'Mode de partage',
            createInstitution:'Créer des institutions',
            createdBy:'Créé par',
            creationDate:'Date de création',
            dataLabel:'Mots-clés',
            sdgGoal:'ODD Objectif ',
            processingMethod:'Méthode de traitement',
            QuoteAddress:'Adresse de citation',
            copyrightNotice:'Avis de droit d’auteur',
            subProjectNumber:'Numéro du sous-projet',
            dataObject:'Objet de données',
            dataIdentification:'Identification des données',
            Description:'Description',
            subjectClassification:'Classification par sujet',
            format:'Format',
            scopeDescription:'Description de la portée',
            releaseAgency:'Mécanisme de libération',
            Email:'E-mail',
            Phone:'Téléphone',
            latestRelease:'Dernière date de sortie',
            totalStorage:'Stockage total',
            totalFiles:'Dossiers total',
            dateScope:'Date Portée',
            resolution:'Résolution',
            copyright:"Droit d'auteur",
            creatingInformation:'Créer des informations',
            releaseNews:'Publier des informations',
            updateDate:'Date de mise à jour',
            fileInformation:'Informations sur fichier',
            productType:'Type de produit',
        },
        close:'Clair',
        metadataDetails:'Détails des métadonnées',
        downloadMetadata:'Télécharger métadonnées',
        relatedResources:'Ressources connexes',
        localFiles:'Fichier local',
        serviceRecord:'Dossier de service',
        relatedDocuments:'Documents connexes',
        addCart:'Sélection actuelle ajouter au panier',
        spaceLocation:'Localisation spatiale',
        lookOtherData:'Personnes qui ont consulté les données ont également consulté',
        relatedRecommendations:'Recommandations connexes',
        noData:'Pas de données'
    },
    DataHub: {
        NotDownload:'Téléchargement n’est pas pris en charge',
        Filter:'Filtre',
        Services: 'Données Services',
        Key: 'Mots-clés',
        Search: 'Rechercher',
        TopSearch: 'Recherche populaire',
        Select: 'Filtres usagés',
        Goal: 'ODD Objectif ',
        Format: 'Format',
        Keywords: 'Mots-clés',
        Source: 'Sources',
        Clear: 'Réinitialisation',
        Close:'Clair',
        All: 'Sélectionner tout',
        Mechanism: 'Mécanisme de libération',
        Date: 'Date de création',
        MoreData: 'Faites défiler vers le bas pour charger plus',
        NoData: 'Pas de données'
    },
    DataInfo2:{
        IdentityInformation:'Informations d’identité',
        Id:'Identificateur',
        Key:'Mots-clés du Thème',
        provider:'Fournisseur',
        DataType:'Type de données',
        Source:'Source des données',
        DataSetFormat:'Format des données',
        ReleaseDate:'Date de sortie',
        DataSetDescriptionInformation:'Informations sur description des données',
        DataSetName:'Nom des données',
        GeographicPosition:'Situation géographique',
        SpatialReference:'Système de référence spatiale',
        Spatial:'Résolution spatiale',
        DistributeandAccessInformation:'Diffuser et accéder aux informations',
        ContactName:'Nom du contact',
        Phone:'Téléphone',
        Email:'E-mail',
        Address:'Adresse',
        PostCode:'Code Postal',
        Permission:'Autorisation',
        
    },
    DataInfo: {

        Overview: 'Aperçu',
        File: 'Fichier local',
        Map: 'Carte',
        Introduction: 'Introduction des données',
        Address: 'Adresse de citation',
        Basic: 'Informations de base',
        Start: 'Date de début',
        End: 'Date de fin',
        Spatial: 'Résolution spatiale',
        Temporal: 'Résolution temporelle',
        Territorial: 'Champ d’application géographique',
        Share: 'Mode de partage',
        Public: 'Partage publique',
        Copyright: "Copyright : Ces données peuvent être utilisées gratuitement à des fins académiques et autres fins non commerciales uniquement. Il ne peut être redistribué ou utilisé à des fins commerciales sans autorisation préalable. Les utilisateurs de ce produit doivent clairement identifier la source et l'auteur.",
        Development: 'En Développement',
        CreateDate: 'Date de création',
        fileNmu: 'Nombre de fichiers',
        seeNum: 'Affichage',
        download: 'Numéro de téléchargement',
        downloadBtn: 'Télécharger',
        otherData: 'Personnes qui ont consulté les données ont également consulté',
        Recommend: "Recommandations connexes",
        Operation: 'Opération'
    },
    App: {
        ExternalApp:'Pour applications externes',
        app9:"Plate-forme intégrée d'aide à la décision pour le développement durable dans la province de Hainan",
        app5:'Plateforme Cloud pour Surveillance Mondiale de l’Agriculture par Télédétection ',
        app6:'Natural and Cultural Heritage Monitoring and Assessment System',
        app7:"Système de surveillance en temps réel par télédétection pour les projets d'ingénierie",
        app8:'国际灾害数据库数据自动获取模块',
        Market: 'Marché des Apps',
        welcome: 'Bienvenue sur le marché des applications de Big Earth Data Système!',
        SDGs: 'Basé sur les 17 objectifs des ODD, le système prend les données statistiques mondiales de la Banque mondiale, de l’OMS, des Nations Unies, de Wikipédia et d’autres organisations comme source de données. En analysant le système d’indices des objectifs de développement durable, l’analyse et le prétraitement de divers produits de données et le calcul de fusion de données multi-sources sont achevés, et l’évaluation quantitative et la visualisation multidimensionnelle des indicateurs des ODD sont réalisées.',
        SatEYE: 'Basé sur des informations spatiales multi-sources, le système peut réaliser une représentation numérique intégrée des éléments clés, des phénomènes et de leurs processus changeants, tels que les ressources naturelles, l’environnement écologique, le changement climatique et les catastrophes, et l’économie sociale le long de « la Ceinture et la Route ». Du côté Web, le système prend en charge l’affichage interactif et réalise la navigation, l’enquête, les statistiques, la cartographie et d’autres fonctions de divers éléments clés, afin de fournir une application d’affichage et de partage de données plus pratique pour la région de « la Ceinture et la Route ».',
        Fire: 'Le système, par l’analyse des données satellitaires, à l’application de l’algorithme de surveillance du site d’incendie et du modèle de propagation du feu, réalise la surveillance normale du site de l’incendie et la découverte, la vérification et le traitement de la situation d’incendie.',
        COVIDTracker: 'Par la collecte de données sur les épidémies, de données sur l’opinion publique, de données socioéconomiques et de données environnementales, et à l’application de modèles de prévision des épidémies et de modèles de migration du personnel, le système permet de visualiser l’augmentation et la répartition de l’épidémie et de prévoir la tendance de l’évolution de l’épidémie, de manière à fournir un appui efficace à la détection des épidémies, à la prévision de la transmission et à l’évaluation des risques.',
        app0:"S'appuyant sur la base de données de base du développement durable dans la province de Hainan, il intègre la méthodologie d'évaluation complète et le modèle d'aide à la décision des indicateurs des ODD dans la province de Hainan, et effectue le suivi de l'état, l'évaluation des tendances et l'évaluation de plus de dix types d'indicateurs des ODD 3, 4, 6, 11, 13, 14 et 15 dans la province de Hainan, et assure le suivi des indicateurs des ODD pour le gouvernement et les secteurs industriels de Hainan, des services d'évaluation des indicateurs et d'aide à la décision pour le gouvernement et les secteurs industriels de la province de Hainan.",
        app1:"Le système a les fonctions suivantes de services de surveillance par télédétection pour les projets d'ingénierie : analyse de l'impact des projets d'ingénierie sur les zones protégées, surveillance de l'impact des projets d'ingénierie sur l'environnement écologique, surveillance de l'avancement de la construction et surveillance de l'impact socio-économique ; gestion de l'ajout, de la suppression et de la vérification des données sur les projets et les services liés à l'ingénierie, achat de données liées à l'ingénierie et envoi de rapports, etc.",
        app2:'研制“一带一路”重大灾害信息网络自动采集模块，包括如下功能模块：(1)最新灾害事件新闻数据的实时网络爬虫抓取模块 (2)国际灾害数据库历史灾害事件数据获取(3)国际灾害事件数据库分析与展示。',
        app3:'Le système permet le chargement et l’affichage de données de masse multi-sources telles que des images de télédétection, le terrain, des modèles tridimensionnels, des vecteurs, des images et des vidéos, l’évaluation des sites patrimoniaux et la tendance à l’évolution des sites patrimoniaux. Elle s’applique à la surveillance dynamique de la gestion et de l’application des sites patrimoniaux nationaux et provinciaux.',
        app4:"La plate-forme, comprenant CropWatch Pro, CropWatch Explorer, CropWatch Analysis et CropWatch Bulletin, est basée sur les dernières données de télédétection, données météorologiques, données d’observation au sol, estimation de la croissance des cultures, rendement et autres informations pertinentes à l’échelle nationale et mondiale.",
        learnMore: 'Entrez app',
        NoMobile:'L’accès à la version mobile n’est pas pris en charge'

    },
    Reports: {
        Reports: 'Suivi des progrès accomplis dans la réalisation des objectifs de développement durable',
        Description: 'De bonnes données et des indicateurs clairs sont essentiels pour que chaque pays puisse évaluer sa position sur les ODD, élaborer une voie pour les atteindre et suivre les progrès. Depuis 2016, SDSN et la Fondation Bertelsmann publient chaque année un index et un tableau de bord mondiaux des ODD. La méthodologie a fait l’objet d’un examen par les pairs (Schmidt-Traub et al. 2017) et d’un examen par le Centre commun de recherche de la Commission européenne (Papadimitriou Neves et Becker 2019) en 2019.  Pour mieux analyser les contextes nationaux et régionaux et améliorer la pertinence des politiques, le SDSN a développé des indices et des tableaux de bord régionaux et infranationaux des ODD en collaboration avec un large éventail de Partenaires.',
        Download: 'Télécharger',
        online: 'Préversion en ligne',

    },
    NewList: {
        New: 'ODD Histoire',
        Society: 'ODD et Société',
        Science: 'ODD et Technologie',
        Practices: 'Meilleures Pratiques',
        Active: 'Nouvelles',
        Time: 'Sélectionner l’heure',
        Goal: 'Sélectionner les objectifs des ODD',
        Search: 'Rechercher',
        Reset: 'Réinitialisation',
        NoData: 'Pas de données',
        More: 'Plus',
        LearnMore: 'Savoir plus',
        Share: 'Partager',
        Report: 'Rapports',
        Video: 'Vidéo des ODD',
        SocietyDescription: 'Le développement social durable est la création de processus durables qui favorisent le bien-être social en comprenant les besoins des citoyens en matière de vie sociale et de travail. L’infrastructure de la vie socioculturelle les équipements sociaux la participation citoyenne et les espaces de développement humain et local sont des indicateurs de la mesure des processus de développement socialement durable. La nature intégrée du Programme 2030 et de ses 17 objectifs de développement durable nécessite une plus grande cohérence des politiques aux niveaux national, régional et international, ce qui peut être réalisé en renforçant les liens entre la recherche en sciences sociales et l’élaboration des politiques publiques.',
        ScienceDescription: 'La durabilité dans la science et la technologie fait référence aux technologies appliquées aux activités et aux actions de durabilité pour l’efficacité en tenant compte des ressources naturelles et en promouvant l’innovation pour le développement économique et social dans le but de réduire considérablement la pollution environnementale et écologique et de créer des ressources durables. La technologie façonne la durabilité et atteint des niveaux plus élevés de productivité et d’efficacité et la plupart des organisations explorent des moyens d’intégrer de nouvelles technologies et mesures pour faire progresser leur développement socio-écologique et leur cadre suivant les objectifs de développement durable (ODD) fixés par l’Assemblée générale des Nations Unies qui devraient être atteints d’ici 2030.',
        CaseDescription: "Introduire les bonnes pratiques des 17 objectifs mondiaux de développement durable promus par tous les secteurs de la société de 2020 à aujourd'hui à travers des cas pratiques de développement durable. Les études de cas rassemblent une série de meilleures pratiques sur « comment » atteindre les objectifs de développement durable du monde et faire progresser les 17 ODD, partager la manière dont les pays mettent en œuvre les ODD dans les domaines de l’eau, de l’énergie, du développement urbain durable, de la biodiversité et de l’environnement, et présenter les bonnes pratiques et les réussites dans la mise en œuvre des ODD.",
        Filter: 'Filtre',
        Tpye: 'Veuillez sélectionner le type de nouvelles',
        Ok: 'Confirmer',
        Canel: 'Canel',
        UnderDevelopment: 'En développement',
        Goal1: 'Pas de pauvreté',
        Goal2: 'Fain «zéro»',
        Goal3: 'Bonne santé et bien-être',
        Goal4: 'Éducation de qualité',
        Goal5: 'Égalité entre les sexes',
        Goal6: 'Eau propre et assainissement',
        Goal7: "Énergie propre et d'un coût abordable",
        Goal8: 'Travail décent et croissance économique',
        Goal9: 'Établir des modes de consommation et de production durables',
        Goal10: 'Inégalités réduites',
        Goal11: 'villes et communautés durables',
        Goal12: 'consommation et production responsables',
        Goal13: 'lutte contre les changements climatiques',
        Goal14: 'Vie aquatique',
        Goal15: 'Vie terrestre',
        Goal16: 'Paix, justice et institutions efficaces',
        Goal17: 'ODD',



    },
    Articles: {
        Like: 'Vous aimerez peut-être',
        Other: 'Autre',
        Home: 'Accueil',
        Details: 'Détails'
    },
    PublicComponents: {
        Cookie: {
            Cookie: 'Nous utilisons des cookies qui sont essentiels pour que vous puissiez accéder à notre site Web et/ou pour vous fournir nos services nous permettent de mesurer et d’améliorer les performances de notre site Web.',
            Accept: 'Accepter tous les cookies',
            AcceptOnly: 'N’accepter que les cookies essentiels'
        },
        ModuleTitle: {
            More: 'Plus'
        },
        Loading:{
            Loading:'Chargement' 
        },
        Footer: {
           
            Nav: 'Navigation',
            DataHub: 'Données Services',
            Society: 'ODD et société',
            Science: 'ODD et science',
            Practices: 'Meilleures Pratiques',
            Knowledge: 'Base de connaissances',
            Link: 'Liens',
            Link1: 'Big Earth Data Sciences Ingénierie Programme',
            Link2: 'CAS Earth Cloud',
            Link3: 'Centre d’Étude Internationale de Big Data pour les ODD',
            Link4: 'Plateforme SDG Big Data',
            Link5: 'Centre d’information sur les réseaux informatiques de l’Académie chinoise des sciences',
            ContactUs: 'Contact',
            Email: 'E-mail',
            Address: 'Adresse',
            AddressInfo: '9 Deng Zhuang South Road, district de Haidian, Pékin',
            WeChat: 'International Research Center of Big Data for Sustainable Development Goals',
            Copyright: 'Copyright @ Big Earth Data Sciences Ingénierie Programme /Digital Belt and Road (DBAR) Programme Pékin',
            Copyright2:'Pékin ICP 17072443',
            Postcode:'Code Postal',
            Phone:'Téléphone'

        }
    },
    User: {
        Header: {
            Title: 'Bienvenue dans DBAR Big Earth Data Système',
            Home: 'Accueil',
        },
        Login:{
            UserName:'Compte',
            Password:'Mot de passe',
            TipUserName:'Veuillez saisir le compte',
            TipPassword:'Veuillez saisir le mot de passe',
            ErrUserName:'Le compte ne peut pas être vide',
            ErrPassword:'Le mot de passe ne peut pas être vide',
            Login:'Pour vous connecter',
            Register:'Pour s’inscrire',
            Forget:'Mot de passe oublié'
        },
        Register:{
            UserName:'Compte',
            Email:'E-mail',
            Code:'Code',
            Password:'Mot de passe',
            ConfirmPassword:'Confirmer le mot de passe',
            TipUserName:'Veuillez saisir le compte',
            TipEmail:'Veuillez entrer l’email',
            TipCode:'Veuillez saisir un code de vérification',
            TipPassword:'Veuillez saisir le mot de passe',
            TipConfirmPassword:'Veuillez confirmer le mot de passe',
            Login:'Pour vous connecter',
            Register:'Pour s’inscrire',
            Forget:'Mot de passe oublié',
            GetCode:'Obtenir le code',
            OK:'Confirmer'
        },
        Forget:{
            UserName:'Compte',
            Email:'E-mail',
            Code:'Code',
            Password:'Mot de passe',
            ConfirmPassword:'Confirmer le mot de passe',
            TipUserName:'Veuillez saisir le compte',
            TipEmail:'Veuillez entrer l’email',
            TipCode:'Veuillez saisir un code de vérification',
            TipPassword:'Veuillez saisir le mot de passe',
            TipConfirmPassword:'Veuillez confirmer le mot de passe',
            Login:'Pour vous connecter',
            Register:'Pour s’inscrire',
            Forget:'Mot de passe oublié',
            GetCode:'Obtenir le code',
            OK:'Confirmer'
        }


    },
    Verification:{
        EmailRegistered:'E-mail est enregistré',
        EmailErr:'Format d’e-mail incorrect',
        UserNameRegistered:'Compte est enregistré',
        UserNameNotExist:'Compte n’existe pas',
        Err:'Opération a échoué',
        getCode:'Obtenir le code',
        OK:'Succès',
        LoginErr:'Le compte ou le mot de passe est incorrect',
        LoginOk:'Connexion réussie'

    },
    About:{
      title:'Centre d’Étude Internationale de Big Data pour les ODD ',
      title_brief:'Introduction',
      brief:'Centre d’Étude Internationale de Big Data pour les ODD vise à exploiter les mégadonnées de la Terre au service du Programme de développement durable à l’horizon 2030 des Nations Unies. Le Centre est hébergé par l’Académie chinoise des sciences (CAS) et propose des recherches multidisciplinaires liées aux sciences sociales et économiques du système terrestre ainsi qu’aux sciences de la durabilité. Plus précisément, le Centre se consacre au suivi et à l’évaluation des indicateurs des ODD dans les domaines où Big Earth Data joue un rôle clé, y compris les biens communs environnementaux, le développement urbain et périurbain, la sécurité alimentaire et la décarbonisation énergétique.',
      title_position:'Positionnement',
      position:'Face à la forte demande de promotion de la mise en œuvre mondiale des ODD, CBAS dirigé par TFM vise à construire la méthode théorique et le système technique des mégadonnées à l’appui des ODD établir une plate-forme scientifique Digital Earth ouverte et partagée diriger le développement de la discipline Big Data pour le développement durable mondial offrir un soutien technique complet au partage de données et des services d’aide à la décision aux agences pertinentes des Nations Unies, ses États membres et la Chine et devenir un Organisation internationale de recherche globale de première classe.',
      title_target:'Objectif',
      target1:'L’objectif global de la CBAS est d’établir une plate-forme technologique publique et une institution de recherche sur les mégadonnées pour le développement durable, ce qui nécessite les efforts combinés de plusieurs parties, y compris le Centre de recherche scientifique du Service d’information sur les données sur le développement durable et le Centre d’innovation technologique Centre de développement des talents Centre de renforcement des capacités Haut de gamme Groupe de réflexion mondial pour le développement durable au service de l’ONU et des pays membres pour mettre en œuvre',
      target2:'La CBAS a joué son rôle dans la recherche de pointe sur la réalisation des ODD soutenue par les mégadonnées internationales en collaboration avec la plate-forme en ligne des Nations Unies pour promouvoir les ODD par l’innovation scientifique et technologique, popularisant l’approche des mégadonnées pour le développement durable dans les pays en développement le long de « la Ceinture et la Route » et accélérant la réalisation des ODD axés sur l’innovation scientifique et technologique.',
      title_active:'Activités de recherche',
      active_title_1:'ODD Big Earth Data Plateforme',
      active_text_1:'Le Centre développera une plate-forme Big Earth Data pertinente pour les ODD avec un service d’analyse de données volumineuses et d’iCloud de calcul haute performance. La plate-forme axée sur les données est équipée pour recevoir les processus de distribution et de partage des données Big Earth et servira d’infrastructure unique pour le suivi et l’évaluation liés aux indicateurs des ODD.',
      active_title_2:'ODD Satellites scientifiques ',
      active_text_2:'Conformément aux besoins spécifiques des indicateurs des ODD, le Centre développera et exploitera des satellites scientifiques de la série des ODD et fournira des sources de données adaptées aux indicateurs pour faciliter la mise en œuvre mondiale des ODD.',
      active_title_3:'Recherche technologique et méthodologique pour le suivi et l’évaluation des ODD',
      active_text_3:'Conformément aux caractéristiques des indicateurs des ODD, le Centre développera des solutions techniques et un système théorique piloté par Big Earth Data pour mieux mesurer les progrès des ODD.',
      active_title_4:'Groupe de réflexion',
      active_text_4:'En mettant l’accent sur l’innovation technologique, le Centre mettra en place un groupe de réflexion pour aborder les problèmes scientifiques qui se posent dans la mise en œuvre du Programme 2030 des Nations Unies et donc pour soutenir l’élaboration de politiques efficaces pour un avenir plus durable.',
      active_title_5:'Éducation et formation',
      active_text_5:'Le Centre fournira un enseignement et une formation professionnels pertinents aux mégadonnées de la Terre pour les pays en développement.'
    },
    Contact:{
        Name:'Centre d’Étude Internationale de Big Data pour les ODD ',
        Addres:'Adresse',
        Postcode:'Code Postal',
        Phone:'Téléphone',
        Fax:'Fax',
        NetWork:'URL',
        Email:'Email',
        AddresText:'9 Deng Zhuang South Road, district de Haidian, Pékin',
        PostcodeText:'100094',
        PhoneText:'+86-10-82178985',
        FaxText:'+86-10-82178980',
        NetWorkText:'sdg.casearth.cn',
        EmailText:'secretariat@cbas.ac.cn',

    },
    // ---------------------



















    login: {
        account: 'Compte',
        password: 'Mot de passe',
        forget: 'Mot de passe oublié',
        login: 'Pour vous connecter',
        register: 'Pour s’inscrire',
        loginError: 'Le compte ou le mot de passe est incorrect',
        tip1: 'Veuillez saisir le compte',
        tip2: 'Veuillez saisir le mot de passe'
    },
    register: {
        register: 'Pour s’inscrire',
        account: 'Compte',
        email: 'E-mail',
        code: 'Code',
        getCode: 'Obtenir le code',
        password: 'Mot de passe',
        confirmPassword: 'Confirmer le mot de passe',
        forget: 'Mot de passe oublié',
        login: 'Pour vous connecter',
        tip1: 'Veuillez saisir le compte',
        tip2: 'Veuillez saisir le mot de passe',
        tip3: 'Veuillez entrer l’email',
        tip4: 'Veuillez saisir un code de vérification',
        tip5: 'Veuillez confirmer le mot de passe',
        checkLogin: 'Le compte a été enregistré, veuillez le saisir à nouveau',
        checkEmail: 'L’e-mail a été enregistré, veuillez le saisir à nouveau',
        LoginNameErr: 'Le compte ne peut pas être vide',
        emailErr: 'Format d’e-mail incorrect',
        accountRegular: 'Noms de compte 4 à 16 bits (souligné alphanumériquement)',
        passwordRegular1: 'Le mot de passe se compose de 6 à 14 chiffres plus des lettres',
        passwordRegular2: 'Le mot de passe ne peut pas être vide',
        passwordRegular3: 'Les deux mots de passe ne correspondent pas',
        codeRegular: 'Veuillez saisir un code de vérification',
        emailRegular1: 'Format d’e-mail incorrect',
        emailRegular2: 'L’adresse e-mail ne peut pas être vide',
    },
    forget: {
        login: 'Pour vous connecter',
        account: 'Compte',
        email: 'E-mail',
        code: 'Code',
        getCode: 'Obtenir le code',
        password: 'Mot de passe',
        confirmPassword: 'Confirmer le mot de passe',
        forget: 'Mot de passe oublié',
        submit: 'Confirmer',
        tip1: 'Veuillez saisir le compte',
        tip2: 'Veuillez confirmer le mot de passe',
        tip3: 'Veuillez entrer l’email',
        tip4: 'Veuillez saisir un code de vérification',
        tip5: 'Veuillez confirmer le mot de passe'
    },
    forgetPassword: {
        forgetPassword: 'Mot de passe oublié',
        toLogin: 'Pour vous connecter',
        submit: 'Envoyer',
        loginNameErr1: 'Le compte ne peut pas être vide',
        loginNameErr2: 'Noms de compte 4 à 16 bits (souligné alphanumériquement)',
        passwordErr1: 'Le mot de passe se compose de 6 à 14 chiffres plus des lettres',
        passwordErr2: 'Le mot de passe ne peut pas être vide',
        passwordErr3: 'Les deux mots de passe ne correspondent pas',
        codeErr: 'Veuillez saisir un code de vérification',
        codeErr1: 'Le code de vérification a été saisi de manière incorrecte',
        emailErr1: 'Format d’e-mail incorrect',
        emailErr2: 'L’adresse e-mail ne peut pas être vide',
        emailErr3: 'L’adresse e-mail a été enregistrée',
        passtip: 'Mot de passe modifié avec succès',

    },
    title: 'DBAR Big Earth Data Système',
    // knowledgeBase: {
    //     sdgs: 'ODD',
    //     indicatorSystem: 'ODD Indicateurs ',
    //     story: 'Données et Histoire',
    //     link: 'Lien',
    //     indicator: 'Indicateur',
    //     series: 'Série',
    //     country: 'Pays',
    //     target: 'Objectifs',
    //     progress: 'Progrès et questions',
    //     goal: 'Objectif atteint',
    //     nodata: "Il n'existe pas de données pour ce pays indicateur",
    //     selectCountry: 'Sélectionner un pays',
    //     confirm: 'Confirmer',

    // },
    knowledgeBase: {
        sdgs: 'SDGs',
        indicatorSystem: 'SDGs Indicators',
        story: 'Data and Story',
        link: 'Link',
        indicator: 'Indicator',
        series: 'Series',
        country: 'Country',
        target: 'Targets',
        progress: 'Progress and issues',
        goal: 'Goal Achievement',
        nodata: 'There is no data for this indicator country',
        selectCountry: 'Select Country',
        confirm: 'Confirm',
    },
    nav: {
        home: 'Accueil',
        share: 'Données Services',
        market: 'Marché des Apps',
        tipPhone: 'La version mobile n’est pas encore disponible, alors restez à l’écoute!'
    },
    titleList: {
        nav: 'Navigation',
        breakingNews: 'Dernière Info',
        socialEconomy: 'ODD et Technologie',
        scientificResearch: 'Meilleures Pratiques',
        practicalCase: 'ODD et Société',
        knowledgeBase: 'Base de Connaissances',
        language: 'Langue',
        more: 'Plus'
    },
    SDG: {

        indicatorsVisualization: 'TerraView-ODD',
        evaluationreport: 'Rapports',
        indicatorsDatabase: 'ODD  indicateurs',


    },
    report: {
        reportSDGs: 'Rapports',
        version: 'Version'
    },
    new: {
        title: 'ODD Actualités ',
        relatedNews: 'Nouvelles connexes',
        oldNews: 'Anciennes nouvelles'
    },
    link: {
        email: 'E-mail',
        relatedLinks: "Liens",
        link1: 'Centre d’Étude Internationale de Big Data pour les ODD ',
        link2: 'Centre d’information sur les réseaux informatiques de l’Académie chinoise des sciences',
        link3: 'Big Earth Data Sciences Ingénierie Programme',
        link4: 'CAS Earth Cloud',
        link5: 'Web des ODD Nations Unies',
        link6: "CAS Earth Big Data Science Project / DBAR International Science Project ",
        contactUs: 'Contact',
        address: 'A1005, Bâtiment de télédétection, 9 Deng Zhuang South Road, district de Haidian, Pékin',
        Copyright: 'Copyright @ Big Earth Data Sciences Ingénierie Programme /Digital Belt and Road (DBAR) Programme Pékin ICP 17072443'
    },
    cookie: {
        cookie: 'Nous utilisons des cookies qui sont essentiels pour que vous puissiez accéder à notre site Web et/ou pour vous fournir nos services nous permettent de mesurer et d’améliorer les performances de notre site Web.',
        accept: 'Accepter tous les cookies',
        acceptOnly: 'N’accepter que les cookies essentiels'
    },
    learnMore: 'Savoir Plus',
    relatedNews: 'Nouvelles connexes',
    SDGRelatedInformation: 'Informations relatives aux ODD',
    filter: 'Filtres',
    SDGAttribution: 'ODD Objectif ',
    dataCategory: 'Format',
    ecologicalAttributes: 'Mots-clés du Thème',
    dataSources: 'Sources',
    label: 'Étiquette',
    creationDate: 'Date de création',
    resolution: 'Résolution',
    dataItem: 'Élément de Données',
    FireForecastingSystem: 'Système de prévision des incendies',
    terraViewSatEye: 'SatEYEs est un outil de cartographie en ligne conçu pour faciliter l’ouverture et le partage des données en fournissant aux gouvernements, aux entreprises et au public un accès facile à des quantités massives de données spatiales.',
    terraViewFire: 'Les feux de forêt présentent des dangers pour les biens et la faune et sont essentiels à la santé de la forêt. TerraView -Fire utilise des satellites de télédétection pour détecter les points d’incendie à l’échelle mondiale et fournit des données historiques sur les incendies et une analyse statistique des incendies.',
    COVIDTracker: 'En collectant et en triant les données liées à la COVID-19, l’application fournit une fenêtre visuelle pour comprendre la distribution mondiale de l’épidémie et les tendances de changement à partir de multiples dimensions et réalise la personnalisation et la sortie des rapports.',
    terraViewSDG: 'En collectant et en triant les données liées aux ODD, l’application fournit une visualisation à l’échelle mondiale des indicateurs des ODD en parcourant les données de calcul des indicateurs des ODD, l’analyse comparative des indicateurs des ODD et la personnalisation et la sortie des graphiques de visualisation.',

    loading: {
        all: 'Terminé',
        more: 'Plus',
        loading: 'Chargement',
        loading1: 'Chargement'
    },
    crumbs: {
        home: 'Accueil'
    },
    dataShare: {
        all: "Sélectionner tout",
        deselectAll: 'Désélectionner tout',
        result: ' 1-Affichage de 10 résultats pour un total de 45 résultats',
        update: 'Date de mise à jour',
        create: 'Date de création',
        relevancy: 'Pertinence',
        imageDatasets: 'Données d’image',
        featureDatasets: 'Données de fonctionnalité',
        forms: 'Données de formes',
        atmospheric: 'Propriétés atmosphériques',
        vegetationCoverage: 'Couverture végétale',
        ecologicalAttributes: 'Attributs écologiques',
        availableDate: 'Date de disponibilité',
        key: 'Mots-clés',
        spatialResolution: 'Résolution spatiale',
        sources: 'Sources',
        label: 'Étiquette',
        dataItem: 'Élément de Données',
        dateCreated: 'Date de création',
        show: 'Montrer',
        back: 'Rentrer',
        dataShare: 'Données Partage',
        createTime: 'Date de création',
        releaseMech: 'Mécanisme de libération',
        SDGsGoal: 'ODD'
    },
    info: {
        spheres: 'Sphères',
        spatialResolution: 'Résolution spatiale',
        temporalResolution: 'Résolution temporelle',
        territorialScope: 'Champ d’application géographique',
        sdg: 'ODD Objectif',
        createInstitutions: 'Créer des institutions',
        creator: 'Créateur',
        creationTime: 'Temps de création',
        dataItem: 'Élément de Données',
    },
    search: {
        placeholder: "Veuillez saisir les critères de recherche ",
        search: 'Rechercher'
    },
    sdgDataBase: {
        sdg: {
            title: 'The 17 Sustainable Development Goals are a blueprint for a better and more sustainable future for all.The goals set out the global challenges we face, including those related to poverty, inequality, climate, environmental degradation, prosperity, and peace and justice.These interconnected goals are designed to leave no one behind, and we must achieve each by 2030',
            GOAL1: 'NO POVERTY',
            GOAL1Value: 'Economic growth must be inclusive to provide sustainable jobs and promote equality.',
            GOAL2: 'ZERO HUNGER',
            GOAL2Value: 'The food and agriculture sector offers key solutions for development, and is central for hunger and poverty eradication.',
            GOAL3: 'GOOD HEALTH AND WELL-BEING',
            GOAL3Value: 'Ensuring healthy lives and promoting the well-being for all at all ages is essential to sustainable development.',
            GOAL4: 'QUALITY EDUCATION',
            GOAL4Value: 'Obtaining a quality education is the foundation to improving people’s lives and sustainable development.',
            GOAL5: 'GENDER EQUALITY',
            GOAL5Value: 'Gender equality is not only a fundamental human right, but a necessary foundation for a peaceful, prosperous and sustainable world.',
            GOAL6: 'CLEAN WATER AND SANITATION',
            GOAL6Value: 'Clean, accessible water for all is an essential part of the world we want to live in.',
            GOAL7: 'AFFORDABLE AND CLEAN ENERGY',
            GOAL7Value: 'Energy is central to nearly every major challenge and opportunity.',
            GOAL8: 'DECENT WORK AND ECONOMIC GROWTH',
            GOAL8Value: 'Sustainable economic growth will require societies to create the conditions that allow people to have quality jobs.',
            GOAL9: 'INDUSTRY, INNOVATION, AND INFRASTRUCTURE',
            GOAL9Value: 'Investments in infrastructure are crucial to achieving sustainable development.',
            GOAL10: 'REDUCED INEQUALITIES',
            GOAL10Value: 'To reduce inequalities, policies should be universal in principle, paying attention to the needs of disadvantaged and marginalized populations.',
            GOAL11: 'SUSTAINABLE CITIES AND COMMUNITIES',
            GOAL11Value: 'There needs to be a future in which cities provide opportunities for all, with access to basic services, energy, housing, transportation and more.',
            GOAL12: 'RESPONSIBLE CONSUMPTION AND PRODUCTION',
            GOAL12Value: 'Ensure sustainable consumption and production patterns',
            GOAL13: 'CLIMATE ACTION',
            GOAL13Value: 'Climate change is a global challenge that affects everyone, everywhere.',
            GOAL14: 'LIFE BELOW WATER',
            GOAL14Value: 'Careful management of this essential global resource is a key feature of a sustainable future.',
            GOAL15: 'LIFE ON LAND',
            GOAL15Value: 'Sustainably manage forests, combat desertification, halt and reverse land degradation, halt biodiversity loss',
            GOAL16: 'PEACE, JUSTICE AND STRONG INSTITUTIONS',
            GOAL16Value: 'Access to justice for all, and building effective, usernameable institutions at all levels.',
            GOAL17: 'PARTNERSHIPS',
            GOAL17Value: 'Revitalize the global partnership for sustainable development.',
        }
    },
    // sdgDataBase: {
    //     sdg: {
    //         title: 'Les 17 objectifs de développement durable sont un modèle pour un avenir meilleur et plus durable pour tous. Les objectifs définissent les défis mondiaux auxquels nous sommes confrontés, y compris ceux liés à l’inégalité de la pauvreté climatique, à la dégradation de l’environnement, à la prospérité, à la paix et à la justice. Ces objectifs interconnectés sont conçus pour ne laisser personne de côté et nous devons les atteindre d’ici 2030.',
    //         GOAL1: 'Pas de pauvreté ',
    //         GOAL1Value: 'Éliminer la pauvreté sous toutes ses formes et partout dans le monde',
    //         GOAL2: 'Fain «zéro»',
    //         GOAL2Value: 'Éliminer la faim, assurer la sécurité alimentaire, améliorer la nutrition et promouvoir l’agriculture durable',
    //         GOAL3: 'Bonne santé et bien-être',
    //         GOAL3Value: 'Permettre à tous de vivre en bonne santé et promouvoir le bien-être de tous à tout âge',
    //         GOAL4: 'Éducation de qualité',
    //         GOAL4Value: 'Assurer l’accès de tous à une éducation de qualité, sur un pied d’égalité, et promouvoir les possibilités d’apprentissage tout au long de la vie',
    //         GOAL5: 'Égalité entre les sexes',
    //         GOAL5Value: 'L’égalité des sexes n’est pas seulement un droit fondamental à la personne, elle est aussi un fondement nécessaire pour l’instauration d’un monde pacifique, prospère et durable.',
    //         GOAL6: 'Eau propre et assainissement',
    //         GOAL6Value: 'Garantir l’accès de tous à des services d’alimentation en eau et d’assainissement gérés de façon durable',
    //         GOAL7: "Énergie propre et d'un coût abordable",
    //         GOAL7Value: 'Garantir l’accès de tous à des services énergétiques fiables, durables et modernes, à un coût abordable',
    //         GOAL8: 'Travail décent et croissance économique',
    //         GOAL8Value: 'Promouvoir une croissance économique soutenue, partagée et durable, le plein emploi productif et un travail décent pour tous',
    //         GOAL9: 'Établir des modes de consommation et de production durables',
    //         GOAL9Value: 'Bâtir une infrastructure résiliente, promouvoir une industrialisation durable qui profite à tous et encourager l’innovation',
    //         GOAL10: 'Inégalités réduites',
    //         GOAL10Value: 'Réduire les inégalités dans les pays et d’un pays à l’autre',
    //         GOAL11: 'villes et communautés durables',
    //         GOAL11Value: 'Faire en sorte que les villes et les établissements humains soient ouverts à tous, sûrs, résilients et durables',
    //         GOAL12: 'consommation et production responsables',
    //         GOAL12Value: 'Adopter des modes de consommation et de production durables',
    //         GOAL13: 'lutte contre les changements climatiques',
    //         GOAL13Value: 'Les changements climatiques affectent désormais tous les pays sur tous les continents. ',
    //         GOAL14: 'Vie aquatique',
    //         GOAL14Value: 'La gestion prudente de cette ressource vitale mondiale est un élément clé pour un avenir durable.',
    //         GOAL15: 'Vie terrestre',
    //         GOAL15Value: 'Préserver et restaurer les écosystèmes terrestres, en veillant à les exploiter de façon durable, gérer durablement les forêts, lutter contre la désertification, enrayer et inverser le processus de dégradation des sols et mettre fin à l’appauvrissement de la biodiversité',
    //         GOAL16: 'Paix, justice et institutions efficaces',
    //         GOAL16Value: 'Assurer l’accès de tous à la justice et mettre en place, à tous les niveaux, des institutions efficaces, responsables et ouvertes à tous',
    //         GOAL17: 'Des partenariats qui contribuent à la réalisation des objectifs',
    //         GOAL17Value: 'Revitaliser le partenariat mondial pour le développement durable.',
    //     },
    // }

}
